import { useState } from 'react'
import type { JSX } from 'react'

import { toast } from '@buffer-mono/popcorn'

import { TimezoneDisplay } from '~publish/components/TimezoneDisplay'
import { CURRENT_TIME_ZONE } from '~publish/helpers/dateFormatters'
import { getGuestAccountUrl } from '~publish/helpers/guestDraftHandoff'
import type { GuestAccountDestination } from '~publish/helpers/guestDraftHandoff'
import type { GuestDraftStore } from '~publish/helpers/guestDrafts'
import { navigateTo } from '~publish/helpers/navigation'
import { PublicFeatureSignupDialog } from '~publish/pages/Create/PublicComposerPage/PublicFeatureSignupDialog'

const RETURN_PATH = '/schedule'

export function PublicTimezoneSignup({
  store,
}: {
  store: GuestDraftStore
}): JSX.Element {
  const [trigger, setTrigger] = useState<HTMLElement>()

  const continueToAccount = (destination: GuestAccountDestination): void => {
    const url = getGuestAccountUrl({
      destination,
      hasGuestDrafts: store.getSnapshot().drafts.length > 0,
      fallbackPath: RETURN_PATH,
    })
    if (!url) {
      toast.error(
        'Your drafts could not be prepared for your account. Please try again.',
      )
      return
    }
    navigateTo(url)
  }

  return (
    <>
      <TimezoneDisplay
        timezone={CURRENT_TIME_ZONE}
        onClick={(event): void => setTrigger(event.currentTarget)}
      />
      {trigger ? (
        <PublicFeatureSignupDialog
          feature="timezone"
          trigger={trigger}
          ctaPrefix="publish-calendar"
          returnPath={RETURN_PATH}
          onClose={(): void => setTrigger(undefined)}
          onContinueToAccount={continueToAccount}
        />
      ) : null}
    </>
  )
}
